module.exports = Object.assign(
  require('./Manufacturing.json'),
  {
  visibility: true,
  image: '/img/dashboard/fertigung.jpg',
  defaultItems: {
    // 'SIGFRM': 1
  },
  orderStatuses: require('../OrderStatuses.js'),
  tabs: [
    require('./Tab0-MasterData.js'),
    require('./Tab1-STL.js'),
    require('./Tab2-Model.js'),
    require('./Tab2-Scans.js'),
    // require('./Tab2-Attachments.js'),
    // require('./Tab3-Addons.js'),
    require('./Tab4-Cart.js'),
  ],

  productTree: require('../ProductTree.json'),
})
